/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Website_Feature_2Inputs */

const et_plan_website_feature_2 = /** @type {(inputs: Plan_Website_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klient saab kiiresti aru, millega sa tegeled`)
};

const en_plan_website_feature_2 = /** @type {(inputs: Plan_Website_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customers quickly understand what you do`)
};

/**
* | output |
* | --- |
* | "Customers quickly understand what you do" |
*
* @param {Plan_Website_Feature_2Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_website_feature_2 = /** @type {((inputs?: Plan_Website_Feature_2Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Website_Feature_2Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_website_feature_2(inputs)
	return en_plan_website_feature_2(inputs)
});